//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.NcmEngRetBuilder.js";
import "../CAM/CAM.ToolPathSplitItemBuilderList.js";
import "../CAM/CAM.ToolPathSplitParametersBuilder.js";
import "../no/ObjectList.js";
let d=[[[1,"HolderClearance",0,"CAM.InheritableToolDepBuilder",0],[1,"NcmEngageRetractBuilder",0,"CAM.NcmEngRetBuilder",0],[1,"NeckClearance",0,"CAM.InheritableToolDepBuilder",0],[1,"OperationList",0,"CAM.ToolPathSplitItemBuilderList",0],[1,"ShankClearance",0,"CAM.InheritableToolDepBuilder",0],[0,"SplitType",1,0],[1,"ToolPathSplitParametersBuilder",0,"CAM.ToolPathSplitParametersBuilder",0],[0,"TransferHeight",1,0],[0,"TransferType",1,0],[0,"TransferUsingMethod",1,0]],[[[],"CreateToolPathSplitItemBuilder",{R_:{builderTag:"CAM.ToolPathSplitItemBuilder"}},0,0]],[]];
SPLM.CAM.ToolPathSplitBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathSplitBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolPathSplitBuilder.SplitTypes = Object.freeze({
    "ByCollision" : "ByCollision", "ByTransfer" : "ByTransfer"});

SPLM.CAM.ToolPathSplitBuilder.TransferUsingMethods = Object.freeze({
    "None" : "None", "RampOnShape" : "RampOnShape", "LiftAndPlunge" : "LiftAndPlunge"});

SPLM.CAM.ToolPathSplitBuilder.TransferTypes = Object.freeze({
    "Direct" : "Direct", "Clearance" : "Clearance", "LowestSafeZ" : "LowestSafeZ"});

export default SPLM;